import React from "react";

const GoogleReviewStar = () => {


    return Array.from({ length: 5 }).map((_, index) => (
        <svg xmlns="http://www.w3.org/2000/svg" width="24px" height="24px" viewBox="0 0 29 29" fill="none">
            <path d="M12.884 2.86542C13.4685 1.68892 15.1468 1.68893 15.7314 2.86543L18.16 7.75332C18.3914 8.21922 18.8362 8.54238 19.3509 8.61856L24.75 9.41782C26.0495 9.6102 26.5682 11.2064 25.6299 12.1259L21.7317 15.946C21.3601 16.3101 21.1902 16.833 21.2768 17.346L22.1851 22.7279C22.4037 24.0233 21.0459 25.0097 19.8815 24.4015L15.0437 21.8746C14.5826 21.6337 14.0328 21.6337 13.5717 21.8746L8.73389 24.4015C7.56945 25.0097 6.21168 24.0232 6.4303 22.7279L7.33858 17.346C7.42516 16.833 7.25526 16.3101 6.8837 15.946L2.9855 12.1259C2.04722 11.2064 2.56584 9.6102 3.8654 9.41782L9.26453 8.61856C9.77916 8.54238 10.2239 8.21922 10.4554 7.75332L12.884 2.86542Z" fill="#FEA500" />
        </svg>
    ))
}

const GoogleReviewsCard = () => {
    return (
        <a href="https://www.google.com/search?q=Seal+Skin+Covers&stick=H4sIAAAAAAAA_-NgU1I1qLCwTDZKTEkzTE01TLG0tEyyMqgwTjMxNTRLM0pOTLM0Mkg1WMQqEJyamKMQnJ2Zp-CcX5ZaVAwA_hFxXzwAAAA&hl=en&mat=CSzZHCRRLD2EElcBa0lj_68IG3hJB7_7pqn7OxYcT4VkRMd4CGK9NXQ4euV8W9GAiaKQiCyHajb_6MrDV-92nwNcqfRgV3Hmn3yOLHYupWp7ooUJE56ATCsTaAbpxymORLA&authuser=0&sei=qcovatnJOviJ7NYPm6OGgAE#lrd=0x89c2adf1ee1d999b:0x3f4516f2caf920e0,1" target="_blank" className="google-reviews-card">
            <div className="google-reviews-card__logo">
                <img src="https://cdn.shopify.com/s/files/1/0168/9760/5686/files/Google__G__Logo_1.svg?v=1781454252" />
            </div>
            <div className="google-reviews-card__divider" />
            <div className="google-reviews-card__content">
                <p className="google-reviews-card__title">Google Rating</p>
                <div className="google-reviews-card__rating">
                    <span className="google-reviews-card__rating-score">4.5</span>
                    <span className="google-reviews-card__rating-stars">
                        <GoogleReviewStar />
                    </span>
                </div>
            </div>
        </a>
    )
}

export default GoogleReviewsCard;